module.exports = __webpack_public_path__ + "img/5C5C5C_A2A2A2_8C8C8C_848484-256px.3a75ad23.png";